import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { PiCaretLeftBold } from "react-icons/pi";
import LockIcon from "../../../assets/icons/lock.svg";
import Input from "../../form/input";
import LoadingButton from "../../common/loadingButton";
import { convertPersianDigitsToEnglish } from "../../../utils/Functions";

// Yup validation schema
const schema = yup.object().shape({
  password: yup.string().required(" رمز عبور الزامی است."),
});

const Password = ({
  phoneNumber,
  setIsOtp,
  loginHandler,
  loading,
  setLoading,
}: any) => {
  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    ...form
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const onSubmit = (data: any) => {
    setLoading(true);
    loginHandler(convertPersianDigitsToEnglish(data.password));
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="flex-1 w-full mt-10 flex flex-col justify-between"
    >
      <div className="flex flex-col">
        <div className="w-full">
          <Input
            form={form}
            errors={errors}
            title="رمز عبور"
            icon={<img src={LockIcon} alt="رمز عبور" />}
            placeholder=""
            id="password"
            type="password"
            direction="ltr"
            style={{ direction: "ltr", letterSpacing: ".3rem" }}
          />
        </div>

        <span
          onClick={() => setIsOtp(true)}
          className="w-fit text-blue-500 text-xs flex items-center cursor-pointer"
        >
          ورود با رمز یک‌بار مصرف
          <PiCaretLeftBold size={13} className="mr-1" />
        </span>
      </div>
      <LoadingButton
        title="ورود"
        type="submit"
        disabled={!isValid || !isDirty || loading}
        loading={loading}
      />
    </form>
  );
};

export default Password;
